// extracted by mini-css-extract-plugin
export default {"data":"BannerStars-module__data__tF1Bt","stars":"BannerStars-module__stars__CKQ0Z","reviews":"BannerStars-module__reviews__oKIzv","star":"BannerStars-module__star__Bf-zk"};